/* wythout-featured-product.js — UI state for sections/wythout-featured-product.liquid.

   Deliberately does NOT implement add-to-cart. The button carries the
   cart-upsell contract (data-cart-upsell-add + data-variant-id +
   data-selling-plan), so the document-delegated listener in
   assets/cart-upsell.js owns the POST /cart/add.js, the drawer re-render, the
   `is-empty` cleanup on <cart-drawer> and opening the drawer. Reusing that one
   pathway is why the two bugs fixed there (spinner cleanup for buttons that
   survive the add, and the stale is-empty class) cannot come back here.

   This file:
     - runs the PDP-hero gallery clone: crossfade slides, prev/next click
       halves, 1/N counter, autoplay (same numbers as assets/media-gallery.js:
       data-autoplay-interval with a 5s default, 6s resume after interaction,
       pause off-screen at 0.4 visibility and while the tab is hidden)
     - tracks the chosen variant, purchase type and selling plan
     - re-renders the prices from the JSON blob the section emits
     - keeps the button's data-variant-id / data-selling-plan / label / disabled
       in sync (label swaps between the one-time and Subscribe wordings, like
       the PDP buy_buttons block)

   Plan ids are handled as STRINGS throughout (the JSON keys are strings and
   the data-plan-id attributes are strings) — same reason the Liquid side
   coerces with `| append: ''`. Never compare one against a number. */
(function () {
  function readData(root) {
    var node = root.querySelector('[data-wy-fp-data]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return (parsed && parsed.variants) || [];
    } catch (e) {
      return [];
    }
  }

  function init(root) {
    if (root.dataset.wyFpReady === 'true') return;
    root.dataset.wyFpReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wy-fp-slide]'));
    var counter = root.querySelector('[data-wy-fp-counter]');
    var prevBtn = root.querySelector('[data-wy-fp-prev]');
    var nextBtn = root.querySelector('[data-wy-fp-next]');

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplayInterval = parseInt(root.dataset.autoplayInterval, 10) || 5000;
    var resumeDelay = 6000;
    var resumeAt = 0;
    var galleryTimer = null;
    var inView = true;
    var galleryIO = null;

    function activeIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function goToSlide(index) {
      var n = slides.length;
      if (n < 2) return;
      var target = slides[((index % n) + n) % n];
      if (!target || target.classList.contains('is-active')) return;
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      target.classList.add('is-active');
      if (counter) counter.textContent = slides.indexOf(target) + 1;
    }

    function pauseAutoplay() {
      resumeAt = Date.now() + resumeDelay;
    }

    function startAutoplay() {
      if (!autoplayEnabled || galleryTimer || slides.length < 2) return;
      galleryTimer = setInterval(function () {
        if (document.hidden || !inView) return;
        if (resumeAt && Date.now() < resumeAt) return;
        goToSlide(activeIndex() + 1);
      }, autoplayInterval);
    }

    function stopAutoplay() {
      if (galleryTimer) {
        clearInterval(galleryTimer);
        galleryTimer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { pauseAutoplay(); goToSlide(activeIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { pauseAutoplay(); goToSlide(activeIndex() + 1); });

    if (autoplayEnabled && slides.length > 1) {
      /* Stored on the root so the shopify:section:unload handler below can
         tear the timer + observer down when the Theme Editor re-renders. */
      var onVisibilityChange = function () {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      if ('IntersectionObserver' in window) {
        galleryIO = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
        }, { threshold: 0.4 });
        galleryIO.observe(root);
      }
      root.__wyFpCleanup = function () {
        stopAutoplay();
        if (galleryIO) galleryIO.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      };
      startAutoplay();
    }

    var variants = readData(root);
    if (!variants.length) return;

    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var atc = root.querySelector('[data-wy-fp-atc]');
    var atcLabel = root.querySelector('[data-role="atc-label"]');
    var subNow = root.querySelector('[data-role="price-subscribe"]');
    var subWas = root.querySelector('[data-role="price-subscribe-was"]');
    var oneNow = root.querySelector('[data-role="price-onetime"]');
    /* The optional `price` block renders snippets/main-product-price.liquid, so the
       figure lives in that snippet's .price__main__value — we hook its wrapper. */
    var priceMain = root.querySelector('[data-role="price-main"] .price__main__value');
    var variantSelect = root.querySelector('[data-wy-fp-variant-select]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-wy-fp-variant-pill]'));
    var cadencePills = Array.prototype.slice.call(root.querySelectorAll('[data-plan-id]'));
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-wy-fp-purchase-option]'));

    var addLabel = (atc && atc.dataset.labelOnetime) || '';
    var subscribeLabel = (atc && atc.dataset.labelSubscribe) || '';
    var soldOutLabel = (atc && atc.dataset.wyFpSoldoutLabel) || '';

    var activeCadence = null;
    for (var ci = 0; ci < cadencePills.length; ci++) {
      if (cadencePills[ci].classList.contains('is-active')) { activeCadence = cadencePills[ci]; break; }
    }

    var state = {
      variantId: root.dataset.wyFpVariant || String(variants[0].id),
      purchase: root.dataset.wyFpPurchase === 'subscribe' ? 'subscribe' : 'onetime',
      plan: activeCadence ? activeCadence.dataset.planId : ''
    };

    function currentVariant() {
      return byId[state.variantId] || variants[0];
    }

    /* Subscribe price for the current variant on the current plan; falls back to
       the one-time price when the variant has no allocation for that plan. */
    function subPrice(variant) {
      if (!state.plan) return variant.oneTime;
      var map = variant.subByPlan || {};
      return Object.prototype.hasOwnProperty.call(map, state.plan) ? map[state.plan] : variant.oneTime;
    }

    function syncMediaToVariant(variant) {
      if (!variant.media) return;
      var target = String(variant.media);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === target) {
          goToSlide(i);
          return;
        }
      }
    }

    function render() {
      var variant = currentVariant();
      var subscribing = state.purchase === 'subscribe';
      var sub = subPrice(variant);

      if (subNow) subNow.textContent = sub;
      if (subWas) {
        // Only worth striking through when the plan actually discounts.
        if (sub !== variant.oneTime) {
          subWas.textContent = variant.oneTime;
          subWas.hidden = false;
        } else {
          subWas.hidden = true;
        }
      }
      if (oneNow) oneNow.textContent = variant.oneTime;
      // main-product-price resolves server-side against the default variant once, so the
      // headline price would otherwise sit on the 24-roll figure while 48 is being added.
      if (priceMain) priceMain.textContent = variant.oneTime;

      options.forEach(function (option) {
        var on = option.dataset.wyFpPurchaseOption === state.purchase;
        option.classList.toggle('is-active', on);
        var radio = option.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });

      pills.forEach(function (pill) {
        var on = pill.dataset.wyFpVariantPill === state.variantId;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (variantSelect && variantSelect.value !== state.variantId) variantSelect.value = state.variantId;

      // One-time clears the pill highlight — nothing is being delivered on a cadence, so
      // no pill reads as pressed. state.plan is kept, so toggling back to Subscribe
      // restores the shopper's cadence (assets/subscription-selector.js does the same).
      cadencePills.forEach(function (pill) {
        var on = subscribing && pill.dataset.planId === state.plan;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (atc) {
        atc.dataset.variantId = state.variantId;
        atc.dataset.sellingPlan = subscribing ? state.plan : '';
        if (variant.available) {
          atc.removeAttribute('disabled');
          if (atcLabel) {
            var next = subscribing && subscribeLabel ? subscribeLabel : addLabel;
            if (next) atcLabel.textContent = next;
          }
        } else {
          atc.setAttribute('disabled', 'disabled');
          if (atcLabel && soldOutLabel) atcLabel.textContent = soldOutLabel;
        }
      }
    }

    function setVariant(id) {
      if (!byId[id] || id === state.variantId) return;
      state.variantId = id;
      // Allocations can differ per variant. subPrice() already falls back to the one-time
      // price, but the button would still post a plan this variant doesn't sell — so drop
      // to a plan it does offer (none → no plan at all) before render() writes it out.
      var planMap = byId[id].subByPlan || {};
      if (!Object.prototype.hasOwnProperty.call(planMap, state.plan)) {
        state.plan = Object.keys(planMap)[0] || '';
      }
      syncMediaToVariant(byId[id]);
      render();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        setVariant(pill.dataset.wyFpVariantPill);
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        setVariant(variantSelect.value);
      });
    }

    cadencePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.plan = pill.dataset.planId;
        // Picking a cadence IS choosing to subscribe — without this the pill lit up while
        // state.purchase stayed 'onetime' and the button added a one-time item under a
        // pressed pill. Same rule as selectPlan() in assets/subscription-selector.js;
        // render()'s options loop re-checks the subscribe radio off state.purchase.
        state.purchase = 'subscribe';
        render();
      });
    });

    options.forEach(function (option) {
      var radio = option.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        state.purchase = option.dataset.wyFpPurchaseOption === 'subscribe' ? 'subscribe' : 'onetime';
        render();
      });
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wy-fp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor re-renders the section wholesale; the fresh copy has no
  // data-wy-fp-ready flag, so this just picks it up — and the outgoing copy's
  // timer + observer are torn down so a detached gallery can't keep ticking.
  document.addEventListener('shopify:section:unload', function (event) {
    var old = event.target.querySelector('[data-wy-fp]');
    if (old && old.__wyFpCleanup) old.__wyFpCleanup();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
